export default "__VITE_ASSET__CJ2VCci7__"